import { render } from "./DetailSgnkso.vue?vue&type=template&id=76fcf015"
import script from "./DetailSgnkso.vue?vue&type=script&lang=js"
export * from "./DetailSgnkso.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__